import React, {Component} from 'react';
import PropTypes from "prop-types";
import "react-modal-video/css/modal-video.min.css";
import CountUp from "react-countup";
import Icofont from "react-icofont";
import VisibilitySensor from "react-visibility-sensor";

class VideoArea extends Component {
  constructor() {
    super();
    this.state = {
      isOpen: false,
      didViewCountUp: false
    };
    this.openModal = this.openModal.bind(this);
  }

  openModal() {
    this.setState({isOpen: true});
  }

  onVisibilityChange = isVisible => {
    if (isVisible) {
      this.setState({didViewCountUp: true});
    }
  };

  render() {
    return (
      <React.Fragment>
        <section className="video-area video-bg">
          <div className="diplay-table">
            <div className="display-table-cell">
              <div className="video-inner-content">
                <div className="row">
                  <div className="col-lg-2 col-md-2 offset-lg-4">
                    <div className="count-box text-center">
                      <div className="glyph">
                        <Icofont icon="icofont-handshake-deal"/>
                      </div>
                      <p>Pacienti</p>
                      <h2 className="counter">
                        <VisibilitySensor
                          onChange={this.onVisibilityChange}
                          offset={{
                            top: 10
                          }}
                          delayedCall
                        >
                          <CountUp
                            start={0}
                            end={
                              this.state.didViewCountUp
                                ? 15
                                : 0
                            }
                            duration={3}
                          />
                        </VisibilitySensor>
                      </h2>
                    </div>
                  </div>

                  <div className="col-lg-2 col-md-2">
                    <div className="count-box text-center">
                      <div className="glyph">
                        <Icofont icon="icofont-checked"/>
                      </div>
                      <p>Camere</p>
                      <h2 className="counter">
                        <VisibilitySensor
                          onChange={this.onVisibilityChange}
                          offset={{
                            top: 10
                          }}
                          delayedCall
                        >
                          <CountUp
                            start={0}
                            end={
                              this.state.didViewCountUp
                                ? 8
                                : 0
                            }
                            duration={3}
                          />
                        </VisibilitySensor>
                      </h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

VideoArea.propTypes = {
  Title: PropTypes.string,
  Content: PropTypes.string,
}
VideoArea.defaultProps = {
  Title: "Watch Video",
  Content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam fermentum sagittis nulla, non vehicula mauris rutrum vitae. Sed non consequat dolor",
}
export default VideoArea;
